// extracted by mini-css-extract-plugin
export default {"separator":"options_separator__9UnFp","heading":"options_heading__bUIgN","singleOptionDisabled":"options_singleOptionDisabled__+kaY6"};